import { render, staticRenderFns } from "./OrganisationEvents.vue?vue&type=template&id=233c2bc6&"
import script from "./OrganisationEvents.vue?vue&type=script&lang=js&"
export * from "./OrganisationEvents.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports